import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "id", "chips", "className", "hasCloseButton", "logo", "metadata", "title"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef, useContext } from 'react';
import cx from 'classnames';
import { prefix } from '../../../tools/settings';
import Chip from '../../Chip';
import Icon from '../../Icon';
import Image from '../../Image';
import { ModalContext } from '../Modal';
import { Styled } from './Header.styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var useModalContext = function useModalContext() {
  return useContext(ModalContext);
};

var ModalHeader = forwardRef(function (_ref, ref) {
  var _cx, _logo$alt, _logo$size, _logo$objectFit;

  var children = _ref.children,
      id = _ref.id,
      chips = _ref.chips,
      customClassName = _ref.className,
      _ref$hasCloseButton = _ref.hasCloseButton,
      hasCloseButton = _ref$hasCloseButton === void 0 ? true : _ref$hasCloseButton,
      logo = _ref.logo,
      metadata = _ref.metadata,
      title = _ref.title,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useModalContext = useModalContext(),
      onClose = _useModalContext.onClose,
      variant = _useModalContext.variant;

  var isBranded = variant === 'branded';
  var className = cx((_cx = {}, _defineProperty(_cx, "".concat(prefix, "-modal__header"), true), _defineProperty(_cx, "".concat(prefix, "-modal__header--branded"), isBranded), _defineProperty(_cx, customClassName, !!customClassName), _cx));
  return _jsxs(Styled.ModalHeader, _objectSpread(_objectSpread({
    ref: ref,
    id: id,
    className: className
  }, rest), {}, {
    children: [isBranded && logo.src && _jsx(Styled.Logo, {
      children: _jsx(Image, {
        src: logo.src,
        alt: (_logo$alt = logo === null || logo === void 0 ? void 0 : logo.alt) !== null && _logo$alt !== void 0 ? _logo$alt : '',
        fallbackSrc: logo.fallbackSrc,
        size: (_logo$size = logo === null || logo === void 0 ? void 0 : logo.size) !== null && _logo$size !== void 0 ? _logo$size : '44px',
        objectFit: (_logo$objectFit = logo === null || logo === void 0 ? void 0 : logo.objectFit) !== null && _logo$objectFit !== void 0 ? _logo$objectFit : 'contain'
      })
    }), _jsxs(Styled.Title, {
      children: [metadata && _jsx(Styled.Metadata, {
        children: metadata
      }), title && _jsx(Styled.Heading, {
        children: title
      }), chips && _jsx(Styled.Chips, {
        children: chips.map(function (chip, index) {
          var _chip$action, _chip$action2, _chip$avatar, _chip$avatar2;

          return _jsx(Chip, {
            mode: isBranded ? 'grey' : 'light',
            action: chip.action && {
              icon: chip === null || chip === void 0 ? void 0 : (_chip$action = chip.action) === null || _chip$action === void 0 ? void 0 : _chip$action.icon,
              onClick: chip === null || chip === void 0 ? void 0 : (_chip$action2 = chip.action) === null || _chip$action2 === void 0 ? void 0 : _chip$action2.onClick
            },
            avatar: chip.avatar && {
              src: chip === null || chip === void 0 ? void 0 : (_chip$avatar = chip.avatar) === null || _chip$avatar === void 0 ? void 0 : _chip$avatar.src,
              name: chip === null || chip === void 0 ? void 0 : (_chip$avatar2 = chip.avatar) === null || _chip$avatar2 === void 0 ? void 0 : _chip$avatar2.name
            },
            hasStatusLight: chip === null || chip === void 0 ? void 0 : chip.hasStatusLight,
            icon: chip === null || chip === void 0 ? void 0 : chip.icon,
            isDisabled: chip === null || chip === void 0 ? void 0 : chip.isDisabled,
            onClick: chip === null || chip === void 0 ? void 0 : chip.onClick,
            status: chip === null || chip === void 0 ? void 0 : chip.status,
            variant: chip === null || chip === void 0 ? void 0 : chip.variant,
            children: chip === null || chip === void 0 ? void 0 : chip.label
          }, index);
        })
      })]
    }), children && _jsx(Styled.Actions, {
      children: children
    }), hasCloseButton && _jsx(Styled.CloseButton, {
      onClick: function onClick() {
        return onClose();
      },
      children: _jsx(Icon, {
        icon: "cross"
      })
    })]
  }));
});
export default ModalHeader;